
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency10AccountShortIntroduction from './digital-currency-10-account-short-introduction.vue'

import {
  GET_ACCOUNT_BY_QR_CODE_REQUEST
} from './service-for-helper-constants/helper-constants-3'

@Component({
  components: {
    DigitalCurrency10AccountShortIntroduction
  }
})
class DigitalCurrency9GetAccountByQrCodeRequestButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean
  @Prop({ default: '' }) accountId?: string

  GET_ACCOUNT_BY_QR_CODE_REQUEST: string = GET_ACCOUNT_BY_QR_CODE_REQUEST

  isVisibleGetAccountByQrCodeRequestDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleGetAccountByQrCodeRequestDialog = isVisible
  }
}

export default DigitalCurrency9GetAccountByQrCodeRequestButton

